module.exports = __webpack_public_path__ + "media/assets/images/confinus_logo-074efe43f3bd6dc831b158ba709566a9.png";